import { AuthError, signInWithEmailAndPassword } from 'firebase/auth';
import { channelLogin } from 'shared/services/backend-api/helpers/auth';
import { getErrorReporter } from 'shared/services/error-tracking';
import { AuthFlowError } from 'shared/types/auth-flow-error';
import { LoginErrorTypes } from 'shared/types/login-form';
import { User } from 'shared/types/user';

import { getUser } from './get-user';
import { getAuthentication } from './helpers';
import { setUserCountry } from './set-user-country';

export const signInUser = async (email: string, password: string) => {
  const auth = await getAuthentication();

  try {
    await signInWithEmailAndPassword(auth, email, password);

    // Authentication already succeeded; a failed profile read must not turn that into a login error.
    let user: User | null = null;

    try {
      user = await getUser();

      if (!user?.settings?.country) {
        await setUserCountry();
      }
    } catch (error) {
      getErrorReporter().captureException(error, {
        tags: { source: 'sign-in-post-auth-user-read' },
      });
    }

    // log other tabs in as well
    channelLogin();

    return user;
  } catch (e) {
    if (
      [
        'auth/user-not-found',
        'auth/invalid-login-credentials',
        'auth/invalid-credential',
        'auth/wrong-password',
      ].includes((e as AuthError)?.code)
    ) {
      throw new AuthFlowError(LoginErrorTypes.WrongCombination);
    }

    getErrorReporter().captureException(e, {
      tags: { source: 'firebase-sign-in' },
    });
    throw new AuthFlowError(LoginErrorTypes.Unknown, { cause: e });
  }
};
